import { FadeIn } from "@/components/FadeIn";
import { SAMPLE_EXCERPT } from "@/data/sample";

export default function Example({ onOpen }) {
  return (
    <section id="example" className="py-16 md:py-24 bg-parchment/40">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <FadeIn className="md:col-span-4">
            <p className="label-eyebrow mb-6">Was entsteht</p>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal leading-[1.1]">
              Ein Entwurf, der nach Ihnen klingt.
            </h2>
            <p className="mt-8 font-serif text-lg text-ink leading-relaxed">
              Kein Schema. Kein Pathos. Ein Text, der Ihre Erinnerungen ordnet —
              und Raum lässt für das, was nur Sie sagen können.
            </p>
            <button
              onClick={onOpen}
              data-testid="example-read-full-button"
              className="mt-10 btn-secondary"
            >
              Vollständiges Beispiel lesen
            </button>
          </FadeIn>

          <FadeIn delay={0.15} className="md:col-span-8">
            <div
              data-testid="example-card"
              className="bg-paper rounded-3xl p-10 md:p-14 shadow-card relative"
            >
              <div className="absolute top-6 left-10 font-display tracking-[0.3em] text-[10px] text-umber">
              Beispiel-Entwurf · Auszug
              </div>
              <div className="mt-8 font-serif italic text-lg md:text-xl text-charcoal leading-[1.85] whitespace-pre-line">
                {SAMPLE_EXCERPT}
              </div>
              <div className="mt-8 pt-8 border-t border-umber/10 font-display tracking-[0.25em] text-[10px] text-umber">
                — Tochter spricht für ihren Vater
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
